import Vue from 'vue';
import Vuex from 'vuex';
import API from './mixins/HandbookAPI';
import moment from 'moment'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        // we dont need to store singular object instance
        OBJ_PARLIAMENTS: [],
        OBJ_PARTIES: [],
        OBJ_STATES: [],
        OBJ_ELECTORATES: [],
        OBJ_PARLIAMENTARIANS: [],
        OBJ_PARLIAMENTARIAN: [],
        OBJ_BIOGRAPHY: [],
        OBJ_RECORDSOFSERVICE: [],
        OBJ_MINISTRIES: [],
        OBJ_COMMITTEES: [],
        OBJ_COMMITTEESERVICE: [],
        OBJ_MINISTRYRECORDS: [],
        OBJ_SHADOWMINISTRIES: [],
        OBJ_SHADOWMINISTRYRECORDS: [],
        OBJ_MINISTRYSTATS: [],
        OBJ_SHADOWMINISTRYSTATS: [],
        OBJ_REFERENDUMS: [],
        OBJ_DISTRIBUTIONS: [],
        OBJ_ERROR: [],
        OBJ_LOADING: [],
        OBJ_YEARS: [2020, 2019, 2018, 2017, 2016, 2015, 2014, 2013, 2012, 2011, 2010, 2009, 2008, 2007, 2006, 2005, 2004, 2003, 2002, 2001, 2000, 1999, 1998, 1997, 1996, 1995, 1994, 1993, 1992, 1991, 1990, 1989, 1988, 1987, 1986, 1985, 1984, 1983, 1982, 1981, 1980],
        OBJ_STATES_ALL: ['ACT', 'NSW', 'NT_', 'QLD', 'SA_', 'TAS', 'VIC', 'WA_'],
        PARLIAMENTS_FILTERED_DEFAULT: 0, // 46,        
        PARLIAMENTARIAN_PER_PAGE: 0,
        ROWS_PER_PAGE: 50,

        //  the below variables are used to set constant relative API paths reducing hard coded values
        API_PARLIAMENTARIANS: "individuals?$orderby=FamilyName,GivenName",
        API_ELECTORATES: "electorates?$select=Electorate,State,Established,Ceased,Origin,Notes&apply=$filter=Electorate ne ''",
        API_PARTIES: "parties?$Select=Name,Abbrev&$filter=Name ne ''",
        API_STATES: "states?$Select=Name,Abbrev&$filter=Name ne ''",
        API_PARLIAMENTS: "parliaments",
        API_COMMITTEES: "committees?Select=CID,CommitteeChamber,CommitteeType,CommitteeName",
        API_COMMITTEESERVICE: "committeemembers?Select=CID,ParentCommitteeMemberID,PHID,ServiceStartDate,ServiceEndDate,ServiceRecordList",
        API_MINISTRIES: "ministries?Select=MID,MIDOrdinal,Name,DateStart,DateEnd",
        API_MINISTRYRECORDS: "ministryrecords",
        API_SHADOWMINISTRIES: "shadowministries",
        API_SHADOWMINISTRYRECORDS: "shadowministryrecords",
        API_SHADOWMINISTRYSTATS: "StatisticalInformation/ShadowMinistries",
        API_MINISTRYSTATS: "StatisticalInformation/Ministries",
        API_REFERENDUMS: "Referendums/ReferendumsAll",
        API_RECORDSOFSERVICE: "recordsofservice?$orderby=OBY,DateStart1,Value1,Value2",
        API_DISTRIBUTIONS: `${API.ApiUri}/Assets/JSON/Distributions`,
        API_HELP: `/api/help/content`,

        //  the below variables are used to set constant relative ROUTE paths reducing hard coded values
        ROUTE_HOME: 'Home',
        ROUTE_PARLIAMENTS: 'Parliaments',
        ROUTE_PARLIAMENTARIANS: 'Parliamentarians',
        ROUTE_PARLIAMENTARIAN: 'Parliamentarian',
        ROUTE_PRIME_MINISTERS: 'PrimeMinistersHistorical',
        ROUTE_ADVANCED_SEARCH: 'AdvancedSearch',
        ROUTE_ELECTORATEMAPS: 'ElectorateMaps',
        ROUTE_ELECTORATES: 'Electorates',
        ROUTE_ELECTORATE: 'Electorate',
        ROUTE_ELECTIONS: 'FullElections',
        ROUTE_REFERENDUMS: 'Referendums',
        ROUTE_ROYAL_COMMISSIONS: 'RoyalCommissions',
        ROUTE_MINISTERIAL_STATEMENTS: 'MinisterialStatements',
        ROUTE_MINISTRIES: 'Ministries',
        ROUTE_MINISTRY: 'Ministry',
        ROUTE_SHADOWMINISTRIES: 'ShadowMinistries',
        ROUTE_SHADOWMINISTRY: 'ShadowMinistry',
        ROUTE_COMMITTEES: 'Committees',
        ROUTE_COMMITTEE: 'Committee',
        ROUTE_PARTIES: 'Parties',
        ROUTE_PARTY: 'Party',
        ROUTE_STATES: 'States',
        ROUTE_STATE: 'State',
        ROUTE_STATISTICAL_INFORMATION: 'StatisticalInformation',
        ROUTE_GENDERCOMPOSITIONOFPARLIAMENT: 'GenderCompositionOfParliament',
        ROUTE_HISTORICAL_INFORMATION: 'HistoricalInformation',
        ROUTE_PRESIDENTS: 'Presidents',
        ROUTE_SPEAKERS: 'Speakers',
        ROUTE_STATUTORY_OFFICE_HOLDERS: 'OfficeHolders',
        ROUTE_GOVERNORS_GENERAL: 'GovernorsGeneral',
        ROUTE_HEADS_OF_STATE: 'HeadsOfState',
        ROUTE_DIAGNOSTICS: 'DIAGNOSTICS',
        ROUTE_HELP: 'Help',

        //  the below variables are used to set constant URL endpoints reducing hard coded values        
        URL_API: `${API.ApiUri}/api`,
        URL_IMAGES: 'https://www.aph.gov.au/api/parliamentarian/{0}/image',
        URL_DISTRIBUTIONS: "/Assets/JSON/Distributions",
        URL_HANDBOOK: API.HandbookUrl,

        STRING_ELECTORATEMAPS: 'Electorate Maps',
        STRING_ESTABLISHED: 'Established',
        STRING_CEASED: 'Ceased',
        STRING_PARLIAMENTARIAN: 'Parliamentarian',
        STRING_PARLIAMENTARIANS: 'Parliamentarians',
        STRING_STATISTICAL_INFORMATION: 'Statistical Information',
        STRING_ADVANCED_SEARCH: 'Advanced Search',
        STRING_MINISTRIES: 'Ministries',
        STRING_DATA_LOADING: "Loading data, please wait.",
        STRING_DATA_NONE: "No data available.",
        STRING_DATA_NORESULTS: "No data found for criteria.",
        STRING_CRLF: '\r\n',

        DATE_CURRENT_PARLIAMENT: '1900-01-01',

        COLOUR_REPRESENTATIVES: '#467664',
        COLOUR_SENATE: '#99504f',
        COLOUR_SENATE_BRIGHT: '#ab112d',
        COLOUR_JOINT: '#4275ae',

        OBJ_APPLICATION_INIT_DATE: new Date(),
        OBJ_APPLICATION_INIT_LOADED: false,

        FILTERS_PARLIAMENTS_SELECTED: [],
        FILTERS_PARLIAMENT_DATES_SELECTED: [],
        FILTERS_PARTIES_SELECTED: [],
        FILTERS_STATES_SELECTED: [],
        FILTERS_GENDER_SELECTED: [],
        FILTERS_MPORSENATOR_SELECTED: [],
        FILTERS_SEARCH_NAME_SELECTED: [],

        GOOGLE_ANALYTICS_ID: API.AnalyticsId,
    },

    getters: {
        GET_PARLIAMENTS(state) {
            return state.OBJ_PARLIAMENTS;
        },

        GET_PARLIAMENTS_ORDERED(state) {
            return state.OBJ_PARLIAMENTS.slice().reverse();
        },

        GET_PARLIAMENTS_ORDERED_WOMENELECTED(state) {
            return state.OBJ_PARLIAMENTS.slice().reverse().filter(p => p.PID > 16);
        },

        GET_PARLIAMENT_BYPID: (state) => (PID) => {
            return state.OBJ_PARLIAMENTS.find(OBJ => OBJ.PID === PID)
        },

        GET_PARTIES(state) {
            return state.OBJ_PARTIES;
        },

        GET_ELECTORATES(state) {
            return state.OBJ_ELECTORATES;
        },

        GET_ELECTORATE_BYNAME: (state) => (ELECTORATE, STATE) => {
            return state.OBJ_ELECTORATES.filter(OBJ_ELECTORATES => OBJ_ELECTORATES.Electorate === ELECTORATE && OBJ_ELECTORATES.State === STATE)
        },

        GET_STATES(state) {
            return state.OBJ_STATES;
        },

        GET_PARLIAMENTARIANS(state) {
            return state.OBJ_PARLIAMENTARIANS;
        },

        GET_PARLIAMENTARIANS_BYSTATEABBREV: (state) => (STATEABBREV) => {
            return state.OBJ_PARLIAMENTARIANS.filter(OBJ => OBJ.RepresentedStates.some(s => s === STATEABBREV))
        },

        GET_PARLIAMENTARIANS_BYPARTY: (state) => (PARTY) => {
            return state.OBJ_PARLIAMENTARIANS.filter(OBJ => OBJ.RepresentedParties.some(p => p === PARTY));
        },

        GET_PARLIAMENTARIAN_BYPHID: (state) => (PHID) => {
            return state.OBJ_PARLIAMENTARIANS.find(OBJ => OBJ.PHID === PHID.toString())
        },

        GET_PARLIAMENTARIAN(state) {
            return state.OBJ_PARLIAMENTARIAN;
        },

        GET_BIOGRAPHY: (state) => {
            return state.OBJ_BIOGRAPHY
        },

        GET_RECORDSOFSERVICE(state) {
            return state.OBJ_RECORDSOFSERVICE
        },

        GET_RECORDSOFSERVICE_BYPHID: (state) => (PHID) => {
            return state.OBJ_RECORDSOFSERVICE.filter(OBJ => OBJ.PHID.toLowerCase() === PHID.toLowerCase())
        },

        GET_MINISTRIES(state) {
            return state.OBJ_MINISTRIES;
        },

        GET_COMMITTEES(state) {
            return state.OBJ_COMMITTEES;
        },

        GET_COMMITTEESERVICE(state) {
            return state.OBJ_COMMITTEESERVICE;
        },

        GET_MINISTRYRECORDS(state) {
            return state.OBJ_MINISTRYRECORDS;
        },

        GET_MINISTRYRECORDS_BYMID: (state) => (MID) => {
            return state.OBJ_MINISTRYRECORDS.filter(OBJ => OBJ.MID === MID)
        },

        GET_SHADOWMINISTRIES(state) {
            return state.OBJ_SHADOWMINISTRIES;
        },

        GET_SHADOWMINISTRYRECORDS_BYSMID: (state) => (SMID) => {
            return state.OBJ_SHADOWMINISTRYRECORDS.filter(OBJ => OBJ.SMID === SMID);
        },

        GET_DISTRIBUTIONS(state) {
            return state.OBJ_DISTRIBUTIONS;
        },

        GET_LOADING(state) {
            return state.OBJ_LOADING;
        },

        GET_APPLICATION_INIT_LOADED(state) {
            return state.OBJ_APPLICATION_INIT_LOADED;
        },

        GET_ERROR(state) {
            return state.OBJ_ERROR;
        },

        GET_YEARS(state) {
            return state.OBJ_YEARS;
        },
    },

    mutations: {
        //
        //  resolved
        OBJ_PARLIAMENTS: (state, data) => {
            state.OBJ_PARLIAMENTS = data;
        },

        OBJ_PARTIES: (state, data) => {
            state.OBJ_PARTIES = data;
        },

        OBJ_STATES: (state, data) => {
            state.OBJ_STATES = data;
        },

        OBJ_ELECTORATES: (state, data) => {
            state.OBJ_ELECTORATES = data;
        },

        OBJ_PARLIAMENTARIANS: (state, data) => {
            state.OBJ_PARLIAMENTARIANS = data;
        },

        OBJ_PARLIAMENTARIAN: (state, data) => {
            state.OBJ_PARLIAMENTARIAN = data;
        },

        OBJ_BIOGRAPHY: (state, data) => {
            state.OBJ_BIOGRAPHY = data;
        },

        OBJ_RECORDSOFSERVICE: (state, data) => {
            state.OBJ_RECORDSOFSERVICE = data;
        },

        OBJ_MINISTRIES: (state, data) => {
            state.OBJ_MINISTRIES = data;
        },

        OBJ_COMMITTEES: (state, data) => {
            state.OBJ_COMMITTEES = data;
        },

        OBJ_COMMITTEESERVICE: (state, data) => {
            state.OBJ_COMMITTEESERVICE = data;
        },

        OBJ_MINISTRYRECORDS: (state, data) => {
            state.OBJ_MINISTRYRECORDS = data;
        },

        OBJ_SHADOWMINISTRIES: (state, data) => {
            state.OBJ_SHADOWMINISTRIES = data;
        },

        OBJ_SHADOWMINISTRYRECORDS: (state, data) => {
            state.OBJ_SHADOWMINISTRYRECORDS = data;
        },


        OBJ_SHADOWMINISTRYSTATS: (state, data) => {
            state.OBJ_SHADOWMINISTRYSTATS = data;
        },

        OBJ_MINISTRYSTATS: (state, data) => {
            state.OBJ_MINISTRYSTATS = data;
        },

        OBJ_REFERENDUMS: (state, data) => {
            state.OBJ_REFERENDUMS = data;
        },

        OBJ_COMMITTEERECORDSOld: (state, data) => {
            state.OBJ_COMMITTEERECORDSOld = data;
        },

        OBJ_DISTRIBUTIONS: (state, data) => {
            state.OBJ_DISTRIBUTIONS = data;
        },

        OBJ_YEARS: (state, data) => {
            state.OBJ_YEARS.push(data);
        },


        OBJ_LOADING: (state, data) => {
            state.OBJ_LOADING.push(data);
        },

        OBJ_APPLICATION_INIT_LOADED: (state, data) => {
            state.OBJ_APPLICATION_INIT_LOADED = data;
        },

        OBJ_ERROR: (state, data) => {
            state.OBJ_ERROR.push(data);
        },

        DATE_CURRENT_PARLIAMENT: (state, data) => {
            state.DATE_CURRENT_PARLIAMENT = data;
        },

    },

    actions: {
        //
        //  IMPORTANT:  
        //  The primary purpose of the below FETCH methods operations is to return ALL relevant records 
        //  for display in the plural Entiry later filtering on local memory JSON objects in the singular
        // 
        FETCH_PARLIAMENTS: (context, { url, mutation }) => {
            API.CURL_PARLIAMENTS(url).then(({ OBJ_PARLIAMENTS }) => {
                context.commit(mutation, OBJ_PARLIAMENTS);
                context.commit('OBJ_LOADING', 'OBJ_PARLIAMENTS loaded');

                context.commit('DATE_CURRENT_PARLIAMENT',
                    {
                        DateStart: context.state.OBJ_PARLIAMENTS.find(OBJ => OBJ.PID == context.state.OBJ_PARLIAMENTS.length).DateElection,
                        DateEnd: context.dispatch('PARLIAMENT_END_DATE', context.state.OBJ_PARLIAMENTS.find(OBJ => OBJ.PID == context.state.OBJ_PARLIAMENTS.length).ParliamentEnd)
                    });
                context.commit('OBJ_APPLICATION_INIT_LOADED', true);

            }).catch((error) => {
                context.commit('OBJ_ERROR', 'Problem Fetching Parliaments: [' + error.toString() + ']');
            });
        },

        PARLIAMENT_END_DATE(thisDate) {
            if (!thisDate || thisDate == '')
                return '2020-12-25'
            else if (thisDate && thisDate != '' && thisDate.length == 10)
                return thisDate
            else
                return '2020-12-25'
        },

        FETCH_PARTIES: (context, payload) => {
            API.CURL_PARTIES(payload.url).then(({ OBJ_PARTIES }) => {
                context.commit(payload.mutation, OBJ_PARTIES);
                context.commit('OBJ_LOADING', 'OBJ_PARTIES loaded');
            }).catch((error) => {
                context.commit('OBJ_ERROR', 'Problem Fetching Parties: [' + error.toString() + ']');
            });
        },

        FETCH_STATES: (context, { url, mutation }) => {
            API.CURL_STATES(url).then(({ OBJ_STATES }) => {
                context.commit(mutation, OBJ_STATES);
                context.commit('OBJ_LOADING', 'OBJ_STATES loaded');
            }).catch((error) => {
                context.commit('OBJ_ERROR', 'Problem Fetching States: [' + error.toString() + ']');
            });
        },

        FETCH_ELECTORATES: (context, { url, mutation }) => {
            API.CURL_ELECTORATES(url).then(({ OBJ_ELECTORATES }) => {
                context.commit(mutation, OBJ_ELECTORATES);
                context.commit('OBJ_LOADING', 'OBJ_ELECTORATES loaded');
            }).catch((error) => {
                context.commit('OBJ_ERROR', 'Problem Fetching Electorates: [' + error.toString() + ']');
            });
        },

        FETCH_PARLIAMENTARIANS: (context, { url, mutation }) => {
            API.CURL_PARLIAMENTARIANS(url).then(({ OBJ_PARLIAMENTARIANS }) => {
                context.commit(mutation, OBJ_PARLIAMENTARIANS);
                context.commit('OBJ_LOADING', 'OBJ_PARLIAMENTARIANS loaded');
            }).catch((error) => {
                context.commit('OBJ_ERROR', 'Problem Fetching Parliamentarians: [' + error.toString() + ']');
            });
        },

        FETCH_RECORDSOFSERVICE: (context, { url, mutation }) => {
            API.CURL_RECORDSOFSERVICE(url).then(({ OBJ_RECORDSOFSERVICE }) => {
                context.commit(mutation, OBJ_RECORDSOFSERVICE);
                context.commit('OBJ_LOADING', 'OBJ_RECORDSOFSERVICE loaded');
                context.commit('OBJ_APPLICATION_INIT_LOADED', true);

            }).catch((error) => {
                context.commit('OBJ_ERROR', 'Problem Fetching Records Of Service: [' + error.toString() + ']');
            });
        },

        FETCH_MINISTRIES: (context, { url, mutation }) => {
            API.CURL_MINISTRIES(url).then(({ OBJ_MINISTRIES }) => {
                context.commit(mutation, OBJ_MINISTRIES);
                context.commit('OBJ_LOADING', 'OBJ_MINISTRIES loaded');
            }).catch((error) => {
                context.commit('OBJ_ERROR', 'Problem Fetching Ministries: [' + error.toString() + ']');
            });
        },

        FETCH_COMMITTEES: (context, { url, mutation }) => {
            API.CURL_COMMITTEES(url).then(({ OBJ_COMMITTEES }) => {
                context.commit(mutation, OBJ_COMMITTEES);
                context.commit('OBJ_LOADING', 'OBJ_COMMITTEES loaded');
                context.commit('OBJ_APPLICATION_INIT_LOADED', true);
            }).catch((error) => {
                context.commit('OBJ_ERROR', 'Problem Fetching Committees: [' + error.toString() + ']');
            });
        },

        // FETCH_COMMITTEESERVICEBeta: (context, { url, mutation }) => {
        //     API.CURL_COMMITTEESERVICEBeta(url).then(({ OBJ_COMMITTEESERVICE }) => {
        //         context.commit(mutation, OBJ_COMMITTEESERVICE);
        //         context.commit('OBJ_LOADING', 'OBJ_COMMITTEESERVICE loaded');
        //         context.commit('OBJ_APPLICATION_INIT_LOADED', true);
        //     }).catch((error) => {
        //         context.commit('OBJ_ERROR', 'Problem Fetching Committee service Beta: [' + error.toString() + ']');
        //     });
        // },

        FETCH_SHADOWMINISTRYSTATS: (context, payload) => {
            API.CURL_SHADOWMINISTRYSTATS(payload.url).then(({ OBJ_SHADOWMINISTRYSTATS }) => {
                context.commit(payload.mutation, OBJ_SHADOWMINISTRYSTATS);
                context.commit('OBJ_LOADING', 'OBJ_SHADOWMINISTRYSTATS loaded');
            }).catch((error) => {
                context.commit('OBJ_ERROR', 'Problem Fetching Shadow Ministry stats: [' + error.toString() + ']');
            });
        },

        FETCH_MINISTRYSTATS: (context, payload) => {
            API.CURL_MINISTRYSTATS(payload.url).then(({ OBJ_MINISTRYSTATS }) => {
                context.commit(payload.mutation, OBJ_MINISTRYSTATS);
                context.commit('OBJ_LOADING', 'OBJ_MINISTRYSTATS loaded');
            }).catch((error) => {
                context.commit('OBJ_ERROR', 'Problem Fetching Ministry stats: [' + error.toString() + ']');
            });
        },

        FETCH_REFERENDUMS: (context, payload) => {
            API.CURL_REFERENDUMS(payload.url).then(({ OBJ_REFERENDUMS }) => {
                context.commit(payload.mutation, OBJ_REFERENDUMS);
                context.commit('OBJ_LOADING', 'OBJ_REFERENDUMS loaded');
            }).catch((error) => {
                context.commit('OBJ_ERROR', 'Problem Fetching Referendums: [' + error.toString() + ']');
            });
        },


        FETCH_MINISTRYRECORDS: (context, payload) => {
            API.CURL_MINISTRYRECORDS(payload.url).then(({ OBJ_MINISTRYRECORDS }) => {
                context.commit(payload.mutation, OBJ_MINISTRYRECORDS);
                context.commit('OBJ_LOADING', 'OBJ_MINISTRYRECORDS loaded');
            }).catch((error) => {
                context.commit('OBJ_ERROR', 'Problem Fetching Ministry Records: [' + error.toString() + ']');
            });
        },

        FETCH_SHADOWMINISTRIES: (context, { url, mutation }) => {
            API.CURL_SHADOWMINISTRIES(url).then(({ OBJ_SHADOWMINISTRIES }) => {
                context.commit(mutation, OBJ_SHADOWMINISTRIES);
                context.commit('OBJ_LOADING', 'OBJ_SHADOWMINISTRIES loaded');
            }).catch((error) => {
                context.commit('OBJ_ERROR', 'Problem Fetching Shadow Ministries: [' + error.toString() + ']');
            });
        },

        FETCH_SHADOWMINISTRYRECORDS: (context, payload) => {
            API.CURL_SHADOWMINISTRYRECORDS(payload.url).then(({ OBJ_SHADOWMINISTRYRECORDS }) => {
                context.commit(payload.mutation, OBJ_SHADOWMINISTRYRECORDS);
                context.commit('OBJ_LOADING', 'OBJ_SHADOWMINISTRYRECORDS loaded');
            }).catch((error) => {
                context.commit('OBJ_ERROR', 'Problem Fetching Shadow Ministry Records: [' + error.toString() + ']');
            });
        },
        
        FETCH_DISTRIBUTIONS: (context, { url, mutation }) => {
            API.CURL_DISTRIBUTIONS(url).then(({ OBJ_DISTRIBUTIONS }) => {
                context.commit(mutation, OBJ_DISTRIBUTIONS);
            }).catch((error) => {
                context.commit('OBJ_ERROR', 'Problem Fetching DISTRIBUTIONS: [' + error.toString() + ']');
            });
        },


        SET_APPLICATION_INIT_LOADED: (context) => {
            context.commit('OBJ_APPLICATION_INIT_LOADED', true);
        },

        PUSH_ERROR: (context, { message }) => {
            try {
                context.commit('OBJ_ERROR', 'Message: [' + message.toString() + ']');
            } catch (error) {
                context.commit('OBJ_ERROR', 'Error: [' + error.toString() + ']');
            }
        },
        GETCSV: (content, { DATA, HEADERS, FILENAME, COMMENT, STRICTHEADERS }) => {
            return new Promise((resolve, reject) => {
                try {
                        //  create Response UTF8 payload with CSV MIME type, compliant with RFC 4180:
                        const { Parser } = require('json2csv');
                        if (STRICTHEADERS) {
                            DATA = new Parser({ fields: HEADERS }).parse(DATA);
                        }
                        else {
                            DATA = new Parser({ HEADERS }).parse(DATA);
                        }
                        
                        if (COMMENT){
                            DATA = "# " + COMMENT + "\r\n" + DATA;
                        }
                        setTimeout(() => { //small timeout to show the loading icon for CSVs
                            var blob = new Blob([DATA], { type: 'text/csv;charset=utf-8;' });
                            
                            if (window.navigator.msSaveOrOpenBlob)  // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
                            {
                                window.navigator.msSaveBlob(blob, FILENAME + ".csv");
                            }
                            else {
                                var a = window.document.createElement("a");
                                a.href = window.URL.createObjectURL(blob, { type: "type: 'text/csv;charset=utf-8" });
                                a.download = FILENAME + ".csv";
                                document.body.appendChild(a);
                                a.click();  // IE: "Access is denied"; see: https://connect.microsoft.com/IE/feedback/details/797361/ie-10-treats-blob-url-as-cross-origin-and-denies-access
                                document.body.removeChild(a);
                            }
                            resolve();
                    }, 150);
                } catch (err) {
                    reject(err);
                }
            });
        }
    }
});
